import { eAchPullPayerType } from '../eAchPullPayerType';
import { eDepositCategory } from '../eDepositCategory';
import { IAchPullDepositData } from '../IAchPullDepositData';

export interface IAchDepositFormData {
  id: string;
  amountCents: number;
  payerType: eAchPullPayerType;
  memo?: string;
  wellsFargoTransactionNumber?: string;
  category?: eDepositCategory;
  ownerId?: string;
  achAccountId?: string;
  createdAt: string;
  version?: 'v1' | 'v2-fees' | 'v2-accounting';

}

export const convertIAchPushDepositDataToIAchDepositFormData = ({
  account,
  id,
  amountCents,
  payerType,
  wellsFargoTransactionNumber,
  category,
  ownerId,
  createdAt,
  version
}: IAchPullDepositData): IAchDepositFormData => ({
  id,
  amountCents,
  payerType,
  wellsFargoTransactionNumber,
  category,
  ownerId,
  achAccountId: account?.id,
  createdAt,
  version
});
